import { render, staticRenderFns } from "./books-preview-audio.vue?vue&type=template&id=1b5e3ac8&"
import script from "./books-preview-audio.vue?vue&type=script&lang=js&"
export * from "./books-preview-audio.vue?vue&type=script&lang=js&"
import style0 from "./books-preview-audio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports